import login from "./login.json"
import signup from "./signup.json"
import forgotPassword from "./forgotPassword.json"
import resetPassword from "./resetPassword.json"
import notifications from "./notifications.json"
import invoices from "./invoices.json"
import manageAccount from "./manageAccount.json"
import textEmp from "./textEmp.json"
import nav from "./nav.json"
import manageOrder from "./manageOrder.json"
import dashboard from "./dashboard.json"
import requestOrder from "./requestOrder.json"
import requestPickup from "./requestPickup.json"
import verifyOtp from "./verifyOtp.json"
import commonModals from "./commonModals.json"
const modules = { login, signup, forgotPassword, resetPassword, notifications, invoices, manageAccount, textEmp, nav, manageOrder, dashboard, requestOrder, requestPickup, verifyOtp, commonModals};

export const getText = (moduleName, key, lang = "en") => {
  const module = modules[moduleName];
  if (!module) return key;

  const entry = module.find((item) => item.id === key);
  if (!entry) return key;

  return entry[lang] || entry["en"] || key;
};
